import { render, staticRenderFns } from "./UploadMembers.vue?vue&type=template&id=ba22491a&"
import script from "./UploadMembers.vue?vue&type=script&lang=js&"
export * from "./UploadMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports